import React, { useState } from "react";
import "./style.scss";
import { AnyFunction } from "../../../../utils/types";

export type FeedbackPayload = {
  resolved: boolean;
  score: number;
  comment: string;
};

type Props = {
    onSubmitFeedback?: AnyFunction;
    /** Lets the user leave without rating; the session still ends. */
    onSkip?: AnyFunction;
  };

const Feedback = ({onSubmitFeedback, onSkip}: Props) => {
  const [resolved, setResolved] = useState<boolean | null>(null); // Track if liked or disliked
  const [score, setScore] = useState<number>(0); // Track score from 1-5
  const [comment, setComment] = useState<string>(""); // Track user comment
  const [step, setStep] = useState<number>(1); // Step in the feedback process

  const handleSubmit = () => {
    const payload: FeedbackPayload = {
      resolved: resolved ?? false,
      score,
      comment,
    };
    onSubmitFeedback?.(payload);
  };

  return (
    <div className="feedback-container">
      {step === 1 && (
        <div className="feedback-step">
          <h3>Did Evie sort out what you needed?</h3>
          <div className="feedback-buttons">
            <button onClick={() => { setResolved(true); setStep(2); }} className="like-button">
              Yes, she did
            </button>
            <button onClick={() => { setResolved(false); setStep(2); }} className="dislike-button">
              Not really
            </button>
          </div>
        </div>
      )}

      {step === 2 && (
        <div className="feedback-step">
          <h3>How would you rate this chat?</h3>
          <div className="feedback-stars">
            {[1, 2, 3, 4, 5].map((star) => (
              <span
                key={star}
                className={`star ${score >= star ? "selected" : ""}`}
                onClick={() => setScore(star)}
              >
                ★
              </span>
            ))}
          </div>
          {score > 0 && (
             <div className="feedback-step">
             <h3>Anything we should know?</h3>
             <textarea
               placeholder="Optional: tell us what worked or what didn't"
               value={comment}
               onChange={(e) => setComment(e.target.value)}
             />
             <button onClick={handleSubmit} className="submit-button">
               Submit
             </button>
           </div>
          )}
        </div>
      )}

      {onSkip && (
        <div className="feedback-skip">
          <button type="button" onClick={onSkip} className="skip-button">
            Skip
          </button>
        </div>
      )}
    </div>
  );
};

export default Feedback;
